import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChange} from "@angular/core";

@Component({
  selector: "boolean-determinant",
  templateUrl: "./boolean-determinant.component.html",
  styles: [],
})
export class BooleanDeterminantComponent implements OnChanges {

  @Input() public booleanValue: boolean;
  @Output() public booleanValueResponse = new EventEmitter();
  @Input() public fields: any [] = [];
  @Input() public sourceFormFieldKey: string;

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (changes.booleanValue && changes.booleanValue.currentValue) {
      this.booleanValue = changes.booleanValue.currentValue;
    }
    if (changes.fields && changes.fields.currentValue) {
      this.fields = this.fields.filter((field) => (field.type === "checkbox"));
    }
  }

  public booleanValueChanged(newValue: boolean) {
    this.booleanValue = newValue;
    this.booleanValueResponse.emit({booleanValue: newValue});
  }

  public onTargetFormFieldKeyChange(event): void {
    this.sourceFormFieldKey = event;
    this.booleanValueResponse.emit({sourceFormFieldKey: this.sourceFormFieldKey});
  }
}
